var render = function render(_c,_vm){return _c('div',{staticClass:"py-3"},[(_vm.props.item[_vm.props.value])?_c('div',{staticClass:"flex items-center justify-center w-5 h-5 text-white bg-green-500 rounded-full"},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'check']}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }